(($, Drupal) => {
  const initToggleDesc = (el) => {
    const $this = $(el);

    const content = $this.find('.toggle-desc__content');
    content.css({ transition: 'height .7s ease-in-out' });
    const contentHeight = content.outerHeight();

    const children = content.children('p, ul, ol, cite, blockquote, dl');
    const visibleElement = children[0];
    const visibleElementHeight = $(visibleElement).outerHeight();
    let siblingsHeight = 0;
    const prevSiblings = $(visibleElement).prevAll();

    if (prevSiblings.length > 0) {
      prevSiblings.each((index, element) => {
        siblingsHeight += $(element).outerHeight();
      });
    }

    const toggler = $(
      '<button class="btn btn--text btn--small has-icon has-icon--add mt-1 has-icon--before toggle-desc__toggler" data-action="expand">Läs mer</button>',
    );

    const onExpandTextEnd = () => {
      content.css('overflow', 'visible');

      content.off('transitionend', null, onExpandTextEnd);
    };

    const onClickToggler = (e) => {
      const { target } = e;
      if ($(target).data('action') === 'expand') {
        content.css({ height: `${contentHeight}px` });
        $(target).data('action', 'collapse');
        $(target).html('Läs mindre');
        $(target).removeClass('has-icon--add');
        $(target).addClass('has-icon--remove');

        content.on('transitionend', onExpandTextEnd);
      } else {
        content.css({ height: `${visibleElementHeight + siblingsHeight}px`, overflow: 'hidden' });
        $(target).data('action', 'expand');
        $(target).html('Läs mer');
        $(target).addClass('has-icon--add');
        $(target).removeClass('has-icon--remove');
      }
    };

    toggler.on('click', (e) => onClickToggler(e));

    if (children.length > 1) {
      $this.append(toggler);

      content.css({ height: `${visibleElementHeight + siblingsHeight}px`, overflow: 'hidden' });
    }
  };

  Drupal.behaviors.mstToggleDesc = {
    attach: (context) => {
      $('.toggle-desc', context).each((index, element) => initToggleDesc(element));
    },
  };
})(jQuery, Drupal);
